
import {getUserInfo} from "@/api/manage"
export default {
    namespaced: true,
    state: {
        userInfo:''
    },
    getters: {},
    mutations: {
        GET_USER_INFO(state,data){
            console.log(data,'GET_USER_INFO')
            state.userInfo=data
            localStorage.setItem('userInfo',JSON.stringify(data));
        }
    },
    actions: {
        async get_user_info({commit, dispatch}) {
            let res = await getUserInfo()
            if(res.code===200){
                commit("GET_USER_INFO", res.data)
            }else{
                console.log(res.msg)
            }
        }

    }
}